<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-greaterEqual`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6734 8.98821C11.9932 8.80785 12.3991 8.92063 12.5797 9.24017C12.7602 9.55989 12.6473 9.96579 12.3277 10.1464L4.32677 14.663C4.00694 14.8436 3.60106 14.7299 3.42052 14.4101C3.24038 14.0904 3.35304 13.6854 3.67247 13.5048L11.6734 8.98821ZM3.42052 1.58782C3.60119 1.26847 4.00715 1.15556 4.32677 1.33587L12.3277 5.85247C12.5363 5.97037 12.6655 6.19199 12.6656 6.43157C12.6655 6.67122 12.5364 6.89277 12.3277 7.01067L4.32677 11.5263C4.00694 11.7068 3.60106 11.5942 3.42052 11.2743C3.24027 10.9546 3.35281 10.5486 3.67247 10.3681L10.6471 6.4306L3.67247 2.49407C3.35291 2.31344 3.24005 1.90754 3.42052 1.58782Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineGreaterEqual',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
